import AdminUserModel from '@models/admin/AdminUserModel';

class AppStore {
	public readonly user = new AdminUserModel();
}

export default new AppStore();
